import { render, staticRenderFns } from "./FaqsCreate.vue?vue&type=template&id=22eb5e88&lang=pug"
import script from "./FaqsCreate.vue?vue&type=script&lang=js"
export * from "./FaqsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports